var map = {
	"./default/cookie-policy.html": 784,
	"./nl-BE/cookie-policy.html": 788
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;



//////////////////
// WEBPACK FOOTER
// ./app/views/legal/partials cookie-policy\.html$
// module id = 463
// module chunks = 11